import { gql } from '../gql';

// This fragment should only be used if
// intending to show Bump UI. Analytics events
// will check this field to determine if
// a listing is shown as bumped.
const ListingsBumpKeyFieldsFragment = gql(`
  fragment BumpKey on Listing {
    _id
    bumpKey {
      key
    }
  }
`);

const ListingsFinancingFieldsFragment = gql(`
  fragment FinancingFields on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
    }
  }
`);

export const ListingImagesFragment = gql(`
  fragment ListingImagesFields on Listing{
    _id
    images(input: {
      transform: "card_square",
      count: 3,
      scope: "photos",
      type: "Product"
    }) {
      _id
      source
    }
    largeSquareImages: images(input: {
      transform: "large_square",
      count: 3,
      scope: "photos",
      type: "Product"
    }) {
      _id
      source
    }
  }
`);

const ListingsShopFieldsFragment = gql(`
  fragment ShopFields on Listing {
    _id
    shop {
      _id
      address {
        _id
        locality
        countryCode
        region
        displayLocation
      }
    }
  }
`);

const ListingsCollectionFragment = gql(`
  fragment ListingsCollection on Listing {
    _id
    id
    usOutlet
    bumped
    categoryUuids
    slug
    title
    description
    listingType
    condition {
      displayName
      conditionSlug
    }
    price {
      amountCents
      display
    }
    pricing {
      buyerPrice {
        display
        currency
        amountCents
      }
      originalPrice {
        display
      }
      ribbon {
        display
        reason
      }
    }
    watching
    state
    stateDescription
    shipping {
      shippingPrices {
        _id
        shippingMethod
        carrierCalculated
        destinationPostalCodeNeeded
        rate {
          amount
          amountCents
          currency
          display
        }
      }
      freeExpeditedShipping
      localPickupOnly
    },
    shop {
      _id
      address {
        _id
        displayLocation
        country {
          _id
          countryCode
          name
        }
      }
    }
    ...AddToCartButtonFields
    ...WatchBadgeData
    ...ListingGreatValueData
    ...ListingCreateOfferButtonData
    ...ListingImagesFields
    ...ListingCardCPOData
  }
`);

export const ListingsCollectionFragments = {
  bumpKey: ListingsBumpKeyFieldsFragment,
  financingFields: ListingsFinancingFieldsFragment,
  listing: ListingsCollectionFragment,
  shopFields: ListingsShopFieldsFragment,
};
